"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDistinctIdCookie = exports.getDistinctIdCookie = void 0;
var uuid_1 = require("uuid");
var deep_equal_1 = __importDefault(require("deep-equal"));
var Storage_1 = __importDefault(require("./Storage"));
var request_1 = __importDefault(require("./request"));
/**
 * Default axe server host.
 */
var DEFAULT_HOST = 'https://axe.deque.com';
/**
 * Default request origin.
 */
/* istanbul ignore next */
var DEFAULT_ORIGIN = (_a = globalThis.location) === null || _a === void 0 ? void 0 : _a.origin;
/**
 * Default storage key.
 */
var LOCAL_STORAGE_KEY = 'distinct_id';
/**
 * Create our storage instance.
 */
var storage = new Storage_1.default();
/**
 * Get the Distinct ID cookie associated with the current user.
 */
var getDistinctIdCookie = function (params) {
    if (params === void 0) { params = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var isLoggedIn, _a, key, _b, host, _c, origin, localCookie, localDistinctId, localKeyCloakId, remoteCookie, remoteDistinctId, remoteKeyCloakId, cookie;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    isLoggedIn = !!params.token;
                    _a = params.key, key = _a === void 0 ? LOCAL_STORAGE_KEY : _a, _b = params.host, host = _b === void 0 ? DEFAULT_HOST : _b, _c = params.origin, origin = _c === void 0 ? DEFAULT_ORIGIN : _c;
                    return [4 /*yield*/, storage.get(key)];
                case 1:
                    localCookie = ((_d.sent()) || {});
                    localDistinctId = localCookie.distinct_id;
                    localKeyCloakId = localCookie.keycloak_id;
                    return [4 /*yield*/, (0, request_1.default)({
                            method: 'GET',
                            host: host,
                            origin: origin,
                            token: params.token
                        })];
                case 2:
                    remoteCookie = (_d.sent()) || {};
                    remoteDistinctId = remoteCookie.distinct_id;
                    remoteKeyCloakId = remoteCookie.keycloak_id;
                    // If the IDs are set AND match, return what was stored. There's nothing left to do.
                    if (localDistinctId &&
                        localDistinctId === remoteDistinctId &&
                        localKeyCloakId &&
                        localKeyCloakId === remoteKeyCloakId &&
                        (0, deep_equal_1.default)(remoteCookie.data, localCookie.data)) {
                        return [2 /*return*/, localCookie];
                    }
                    cookie = {
                        // so this is never undefined
                        distinct_id: ''
                    };
                    if (!remoteDistinctId && !localDistinctId) {
                        // Neither localStorage nor the cookie had the ID. We generate a new ID, set it in localStorage and attempt to set the cookie.
                        cookie.distinct_id = (0, uuid_1.v4)();
                        cookie.keycloak_id = remoteKeyCloakId || localKeyCloakId;
                        if (remoteKeyCloakId === localKeyCloakId || !localKeyCloakId) {
                            // merge
                            cookie.data = __assign(__assign({}, localCookie.data), remoteCookie.data);
                        }
                        else {
                            // overwrite
                            cookie.data = remoteCookie.data;
                        }
                        return [2 /*return*/, (0, exports.setDistinctIdCookie)(cookie, params)];
                    }
                    if (!remoteDistinctId) return [3 /*break*/, 15];
                    if (!!remoteKeyCloakId) return [3 /*break*/, 10];
                    if (isLoggedIn) {
                        // logged in without remote Keycloak ID
                        // all we need to do is resolve conflicts in data and post back
                        cookie.distinct_id = remoteDistinctId;
                        if (localDistinctId !== remoteDistinctId) {
                            cookie.data = remoteCookie.data;
                        }
                        else {
                            cookie.data = __assign(__assign({}, localCookie.data), remoteCookie.data);
                        }
                        // Post differences back to server
                        return [2 /*return*/, (0, exports.setDistinctIdCookie)(cookie, params)];
                    }
                    if (!!localDistinctId) return [3 /*break*/, 5];
                    cookie.distinct_id = remoteDistinctId;
                    cookie.data = __assign(__assign({}, localCookie.data), remoteCookie.data);
                    if (!(0, deep_equal_1.default)(cookie.data, remoteCookie.data)) return [3 /*break*/, 4];
                    return [4 /*yield*/, storage.set(key, cookie)];
                case 3:
                    _d.sent();
                    return [2 /*return*/, cookie];
                case 4: 
                // Post differences back to server
                return [2 /*return*/, (0, exports.setDistinctIdCookie)(cookie, params)];
                case 5:
                    if (!(localDistinctId !== remoteDistinctId)) return [3 /*break*/, 7];
                    // overwrite local storage
                    return [4 /*yield*/, storage.set(key, remoteCookie)];
                case 6:
                    // overwrite local storage
                    _d.sent();
                    return [2 /*return*/, remoteCookie];
                case 7:
                    if (localKeyCloakId) {
                        // merge cookies for post to server
                        cookie.keycloak_id = localKeyCloakId;
                        cookie.distinct_id = localDistinctId;
                        cookie.data = __assign(__assign({}, localCookie.data), remoteCookie.data);
                        // Post differences back to server
                        return [2 /*return*/, (0, exports.setDistinctIdCookie)(cookie, params)];
                    }
                    cookie.distinct_id = remoteDistinctId;
                    cookie.data = __assign(__assign({}, localCookie.data), remoteCookie.data);
                    if (!(0, deep_equal_1.default)(cookie.data, remoteCookie.data)) return [3 /*break*/, 9];
                    return [4 /*yield*/, storage.set(key, cookie)];
                case 8:
                    _d.sent();
                    return [2 /*return*/, cookie];
                case 9: 
                // Post differences back to server
                return [2 /*return*/, (0, exports.setDistinctIdCookie)(cookie, params)];
                case 10:
                    if (!(localDistinctId && remoteDistinctId !== localDistinctId)) return [3 /*break*/, 12];
                    if (!(remoteKeyCloakId !== localKeyCloakId)) return [3 /*break*/, 12];
                    // overwrite everything with the cookie
                    return [4 /*yield*/, storage.set(key, remoteCookie)];
                case 11:
                    // overwrite everything with the cookie
                    _d.sent();
                    return [2 /*return*/, remoteCookie];
                case 12:
                    // merge the data
                    cookie.distinct_id = remoteDistinctId;
                    cookie.keycloak_id = remoteKeyCloakId;
                    cookie.data = __assign(__assign({}, localCookie.data), remoteCookie.data);
                    if (!(0, deep_equal_1.default)(cookie.data, remoteCookie.data)) return [3 /*break*/, 14];
                    return [4 /*yield*/, storage.set(key, cookie)];
                case 13:
                    _d.sent();
                    return [2 /*return*/, cookie];
                case 14: 
                // Post differences back to server
                return [2 /*return*/, (0, exports.setDistinctIdCookie)(cookie, params)];
                case 15:
                    // cookie has no distinct_id, we need to always post
                    if (!remoteKeyCloakId || remoteKeyCloakId === localKeyCloakId) {
                        // We know this (the local ID) is a string at this point.
                        cookie.distinct_id = localDistinctId;
                        cookie.keycloak_id = localKeyCloakId; // does not matter if it does not match, the server will nuke it
                        cookie.data = __assign(__assign({}, localCookie.data), remoteCookie.data);
                    }
                    else {
                        cookie.distinct_id = (0, uuid_1.v4)();
                        cookie.keycloak_id = remoteKeyCloakId;
                        cookie.data = remoteCookie.data;
                    }
                    return [2 /*return*/, (0, exports.setDistinctIdCookie)(cookie, params)];
            }
        });
    });
};
exports.getDistinctIdCookie = getDistinctIdCookie;
/**
 * Get the Distinct ID associated with the current user.
 */
var getDistinctId = function (params) {
    if (params === void 0) { params = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var cookie;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, exports.getDistinctIdCookie)(params)];
                case 1:
                    cookie = _a.sent();
                    return [2 /*return*/, cookie.distinct_id];
            }
        });
    });
};
exports.default = getDistinctId;
/**
 * Set the distinct ID associated with the current user.
 */
var setDistinctIdCookie = function (cookie, _a) {
    var _b = _a === void 0 ? {} : _a, 
    // istanbul ignore next
    _c = _b.key, 
    // istanbul ignore next
    key = _c === void 0 ? LOCAL_STORAGE_KEY : _c, 
    // istanbul ignore next
    _d = _b.host, 
    // istanbul ignore next
    host = _d === void 0 ? DEFAULT_HOST : _d, 
    // istanbul ignore next
    _e = _b.origin, 
    // istanbul ignore next
    origin = _e === void 0 ? DEFAULT_ORIGIN : _e, token = _b.token;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0: return [4 /*yield*/, storage.set(key, cookie)];
                case 1:
                    _f.sent();
                    return [4 /*yield*/, (0, request_1.default)({
                            method: 'POST',
                            host: host,
                            origin: origin,
                            token: token,
                            payload: cookie
                        })];
                case 2:
                    _f.sent();
                    return [2 /*return*/, cookie];
            }
        });
    });
};
exports.setDistinctIdCookie = setDistinctIdCookie;
//# sourceMappingURL=getDistinctId.js.map